import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './connections.less';
import { connectIntegration, disconnectIntegration } from '../../redux/actions/integrationsConnectionActions';
import netdocsIcon from './icons/netdocuments.png';
import NetDocumentsAuthenticator from "./NetDocumentsAuthenticator";
import { Modal, Panel, Button } from 'react-bootstrap';
import { notify } from 'common/Notification';

export default class NetDocumentsSwitch extends Component {
  static defaultProps = {
    connectionId: null,
  };

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number,
    agreedToPricing: PropTypes.bool.isRequired,
  };

  state = {
    loading: false,
    showRegionDialog: false,
    scopes: {
      read: true,
      edit: true,
      organize: true,
      delete_doc: true,
      delete_container: false,
    },
  };

  selectRegion(selectedRegion) {
    this.setState(selectedRegion);
    this.connectNetDocuments();
  }

  connectNetDocuments(region) {
    this.setState({
      loading: true,
      showRegionDialog: false,
      region,
    });

    const scopes = Object.keys(this.state.scopes)
      .filter(key => this.state.scopes[key])
      .join(' ');

    NetDocumentsAuthenticator(region)
      .login({
        scope: scopes,
        state: {
          redirect_host: window.location.host,
          region,
        }
      })
      .then(
        ({authResponse}) => {
          this.props.dispatch(connectIntegration('files', 'netdocuments', authResponse));
          this.setState({loading: false});
        },
        (res) => {
          const {code, message} = res.error;
          this.setState({loading: false});
          notify.error(`Error connecting to NetDocuments: [${code}] ${message || ''}`);
        }
      )
  }

  showRegionChooser = () => {
    this.setState({showRegionDialog: true});
  }

  hideRegionChooser = () => {
    this.setState({showRegionDialog: false});
  }

  onClick = () => {
    const {connectionId} = this.props;

    if (connectionId === null) {
      this.showRegionChooser();
      return;
    }
    else {
      // disconnect from netdocuments
      this.props.dispatch(disconnectIntegration(connectionId));
    }
  }

  render() {
    const { connectionId, agreedToPricing } = this.props;
    const iconCls = `kloudless-switch ${connectionId ? 'on' : ''} ${agreedToPricing ? '' : 'hidden'}`;

    return (
      <div className="kloudless-control-holder2" >
        <img className="kloudless-connection-icon"
             src={netdocsIcon}
             alt="logo"
        />

        <div className={iconCls} onClick={this.onClick} >
          { this.state.loading
          && <i
            className={"fa fa-circle-o-notch fa-spin"}
            style={{ marginTop: '10px', marginLeft: '11px', fontSize: '11px' }}

          />}
        </div>

        <Modal show={this.state.showRegionDialog} onHide={this.hideRegionChooser}>
          <Modal.Header closeButton>
            <Modal.Title>Select NetDocuments Region</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel>
              <Panel.Body>
                <Button style={{width: '100%'}} bsStyle="primary" onClick={() => this.connectNetDocuments('US')}>US - vault.netvoyage.com</Button>
                <br/>
                <Button style={{width: '100%', marginTop: '1em'}} onClick={() => this.connectNetDocuments('DE')}>DE - de.netdocuments.com</Button>
                <br/>
                <Button style={{width: '100%', marginTop: '1em'}} onClick={() => this.connectNetDocuments('EU')}>EU - eu.netdocuments.com</Button>
                <br/>
                <Button style={{width: '100%', marginTop: '1em'}} onClick={() => this.connectNetDocuments('AU')}>AU - eu.netdocuments.com</Button>
              </Panel.Body>
            </Panel>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Integrations/connections/NetDocumentsSwitch.jsx